import React from "react";

function SubHeader(props) {
  return (
    <div className="p-3 border-bottom w-100 text-left">
      <h2
        id={props?.id || props?.content}
        className="font-open-sans fw-n"
        style={{ textAlign: "left" }}
      >
        {props?.content}
      </h2>
    </div>
  );
}

export default React.memo(SubHeader);
